import moment from 'moment'
import React from 'react'
import utils from '../../utils'
import { ImCancelCircle } from "react-icons/im";
import { FaCheckCircle, FaMapMarkedAlt } from "react-icons/fa";
import LocationModal from '../dashboard/LocationModal';

function NurseDetails({ userObject }) {
    const getFileName = (url) => url?.split('/').pop() || '-';
    return (
        <div className='space-y-5'>
            <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark  p-3 md:p-5 px-4 py-4 md:py-6 md:px-6 pb-6 space-y-5">
                <div>
                    <h3 className="text-xl font-bold text-gray-800">
                        Account Details
                    </h3>
                </div>
                <div className='flex justify-center md:justify-start'>
                    <div className="avatar placeholder">
                        {userObject?.user?.image ? (
                            <div className="w-20 rounded-full">
                                <img src={userObject?.user.image} alt={userObject?.user.email} />
                            </div>
                        ) : (
                            <div className="bg-neutral text-white rounded-full w-20">
                                <span className="text-3xl">
                                    {utils.makeProfileLetter(userObject?.user)}
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                    {userObject?.user?.full_name && (
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Full Name
                            </label>
                            <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                                {userObject?.user.full_name}
                            </p>
                        </div>
                    )}

                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Email Address
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {userObject?.user?.email}
                        </p>
                    </div>

                    {userObject?.user?.phone_number && (
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Phone Number
                            </label>
                            <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                                {userObject?.user.phone_number}
                            </p>
                        </div>
                    )}

                    <div className="">
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                            Account Type:
                        </label>
                        <p className="mt-1 items-center gap-2">
                            <span className="px-3 py-1 bg-primary/10 text-primary dark:bg-red-900/30 dark:text-red-300 text-xs font-semibold rounded-full">
                                {userObject?.user?.role}
                            </span>
                        </p>
                    </div>

                    {userObject?.user?.role === 'Nurse' && (
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                                Account Verified:
                            </label>
                            <p className="mt-1 items-center gap-2">
                                {userObject?.user?.is_verified ? (
                                    <FaCheckCircle className='text-primary h-5 w-5' />
                                ) : (
                                    <ImCancelCircle className='text-error h-5 w-5' />
                                )}
                            </p>
                        </div>
                    )}

                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Member Since
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {userObject?.user?.creation_time
                                ? moment(userObject?.user.creation_time).fromNow()
                                : '-'}
                        </p>
                    </div>
                </div>
            </div>
            {userObject?.user?.role === 'Nurse' ? (
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark  p-3 md:p-5 px-4 py-4 md:py-6 md:px-6 pb-6 space-y-5">
                    <div>
                        <h3 className="text-xl font-bold text-gray-800">
                            Nurse Details
                        </h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Licence Number
                            </label>
                            <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                                {userObject?.license_number || '-'}
                            </p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Years of Experience
                            </label>
                            <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                                {userObject?.years_of_experience || '-'}
                            </p>
                        </div>
                        <div className="col-span-1 md:col-span-2">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Skills
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.skills && userObject.skills.length > 0 ? (
                                    userObject.skills.map((skill) => (
                                        <span
                                            key={skill.id}
                                            className="text-sm text-gray-800 dark:text-gray-200 font-medium bg-gray-100 dark:bg-gray-700/50 px-2.5 py-1 rounded-md"
                                        >
                                            {skill.name}
                                        </span>
                                    ))
                                ) : (
                                    <span className="text-gray-800 dark:text-gray-200 font-medium">-</span>
                                )}
                            </div>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                                Document:
                            </label>
                            <p className="mt-1 items-center gap-2">
                                {userObject?.document ? (
                                    <span>
                                        <a target='_blank' href={userObject?.document} className='hover:cursor-pointer hover:underline text-primary' rel="noreferrer">
                                            {getFileName(userObject?.document)}
                                        </a>
                                    </span>
                                ) : (
                                    <p className='text-gray-800 dark:text-gray-200 font-medium'>-</p>
                                )}
                            </p>
                        </div>
                        <div>
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                                Account Suspended:
                            </label>
                            <p className="mt-1 items-center gap-2">
                                {userObject?.is_suspended ? (
                                    <FaCheckCircle className='text-error h-5 w-5' />
                                ) : (
                                    <ImCancelCircle className='text-primary h-5 w-5' />
                                )}
                            </p>
                        </div>

                    </div>
                </div>
            ) : (
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark  p-3 md:p-5 px-4 py-4 md:py-6 md:px-6 pb-6 space-y-5">
                    <div>
                        <h3 className="text-xl font-bold text-gray-800">
                            Patient Details
                        </h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                        <div className="">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Age
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.age || '-'}
                            </div>
                        </div>
                        <div className="col-span-1 md:col-span-2">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Conditions
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.conditions && userObject.conditions.length > 0 ? (
                                    userObject.conditions.map((condition) => (
                                        <span
                                            key={condition.id}
                                            className="text-sm text-gray-800 dark:text-gray-200 font-medium bg-gray-100 dark:bg-gray-700/50 px-2.5 py-1 rounded-md"
                                        >
                                            {condition.name}
                                        </span>
                                    ))
                                ) : (
                                    <span className="text-gray-800 dark:text-gray-200 font-medium">-</span>
                                )}
                            </div>
                        </div>
                        <div className="col-span-1 md:col-span-2">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Notes
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.condition_notes ? (
                                    <div>
                                        <p className='text-gray-800 dark:text-gray-200 font-medium whitespace-pre-wrap'>{userObject?.condition_notes}</p>
                                    </div>
                                ) : (
                                    <span className="text-gray-800 dark:text-gray-200 font-medium">-</span>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            )}
            {userObject?.location?.lat && userObject?.location?.lng && (
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark  p-3 md:p-5 px-4 py-4 md:py-6 md:px-6 pb-6 space-y-5">
                    <div className='flex justify-between items-center'>
                        <h3 className="text-xl font-bold text-gray-800">
                            Location
                        </h3>
                        <div>
                            <div
                                onClick={() => {
                                    document.getElementById('location-open-btn')?.click();
                                }}
                                className='btn btn-accent text-white'
                            >
                                <FaMapMarkedAlt /> Open Map
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                        <div className="">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                Address
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.location?.address || '-'}
                            </div>
                        </div>
                        <div className="">
                            <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                                City
                            </label>
                            <div className="mt-1 flex flex-wrap gap-2">
                                {userObject?.location?.city || '-'}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {userObject?.location?.lat && userObject?.location?.lng && (
                <LocationModal
                    lat={userObject?.location?.lat}
                    lng={userObject?.location?.lng}
                    activeUser={userObject?.user}
                />
            )}
        </div>
    )
}

export default NurseDetails